import { theme } from '@theme';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useCheckDevice } from '../../../../hooks/UseCheckDevice';
import { UserProfileFormResource } from '../../../../types/header/UserProfile';
import { RowDivider } from '../UserProfileStyles';

type UserProfilePreferenceProps = {
  isPrimaryUser: boolean;
  isIncentiveAdvantageType: boolean;
  isEssentialType: boolean;
};

const UserProfilePreference: FC<UserProfilePreferenceProps> = (props) => {
  const { isPrimaryUser, isIncentiveAdvantageType, isEssentialType } = props;
  const { register } = useFormContext<UserProfileFormResource>();
  const { isMobileDevice } = useCheckDevice();

  return (
    <>
      {!isPrimaryUser && !isIncentiveAdvantageType && (
        <RowDivider
          borderColor={isMobileDevice ? theme.palette.backgroundGray : theme.palette.lightGreySix}
        >
          <div className='form-horizontal'>
            <div className='col-sm-12 col-xs-12'>
              <div className='form-group pb-3 mb-0'>
                <div className='col-sm-12 col-xs-12'>
                  <label className='control-label'>Email Notifications</label>
                  <div className='nice-checkboxes'>
                    <label>
                      <input type='checkbox' {...register('realtimeServiceArrivalEmail')} />
                      <em>Receive Realtime Service Arrival Emails</em>
                    </label>
                  </div>
                </div>
                <div className='col-sm-12 col-xs-12'>
                  <div className='nice-checkboxes'>
                    <label>
                      <input type='checkbox' {...register('serviceArrivalEmail')} />
                      <em>Receive Daily Service Appointment Email</em>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </RowDivider>
      )}
      {!isPrimaryUser && !isIncentiveAdvantageType && !isEssentialType && !isMobileDevice && (
        <div className='row'>
          <div className='form-horizontal'>
            <div className='col-sm-12 col-xs-12'>
              <label className='control-label'>Default Home Page</label>
              <p className='sub-text'>
                Select a page to be your home page. You can return to it at any time by clicking on
                the MEQ logo in the header.
              </p>
              <div className='form-group nice-radiobuttons mb-0' style={{ display: 'flex' }}>
                <div className='col-sm-4 col-xs-4'>
                  <label>
                    <input type='radio' value={7} {...register('homePagePreference')} />
                    <span>Portfolio (All)</span>
                  </label>
                </div>
                <div className='col-sm-4 col-xs-4'>
                  <label>
                    <input type='radio' value={0} {...register('homePagePreference')} />
                    <span>Lease Portfolio</span>
                  </label>
                </div>
                <div className='col-sm-4 col-xs-4'>
                  <label>
                    <input type='radio' value={1} {...register('homePagePreference')} />
                    <span>Finance Portfolio</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserProfilePreference;
